import { Heart, Users, EyeOff, Calendar, Smile } from "lucide-react";

const benefits = [
  {
    icon: Heart,
    title: "Calmer dinners",
    text: "Trade negotiating for laughter. The pressure leaves the table — and so does the dread.",
  },
  {
    icon: Users,
    title: "Real kid participation",
    text: "Tiny hands stirring, plating, telling the story of the meal. Ownership, not orders.",
  },
  {
    icon: EyeOff,
    title: "Screen-free connection",
    text: "Characters and stories do what tablets do, without trading away the conversation.",
  },
  {
    icon: Calendar,
    title: "A routine that sticks",
    text: "Repeatable rituals build confidence — for kids learning to eat and parents learning to relax.",
  },
  {
    icon: Smile,
    title: "Food curiosity, not pressure",
    text: "Kids remember the adventure first. New flavors stop feeling like a test.",
  },
];

export default function ParentBenefits() {
  return (
    <section data-testid="section-benefits" className="relative py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-extrabold uppercase tracking-widest text-pb-coral">The transformation parents notice</p>
          <h2 className="font-display font-black text-4xl md:text-5xl mt-3 leading-tight">
            Less stress at dinner. <br className="hidden sm:block" /> More <span className="wavy">connection</span> after it.
          </h2>
          <p className="mt-4 text-pb-soft text-lg">
            Plate Buddies isn't a gadget — it's a small, repeatable shift that changes how your family experiences mealtime.
          </p>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              data-testid={`card-benefit-${i}`}
              className="rounded-3xl p-6 bg-pb-cream border border-pb-sky/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="h-11 w-11 rounded-2xl bg-white flex items-center justify-center shadow-sm">
                <b.icon className="h-5 w-5 text-pb-coral" />
              </div>
              <h3 className="font-display font-black text-lg mt-4 leading-tight">{b.title}</h3>
              <p className="text-pb-soft mt-2 text-sm leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
